import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
  };

  static targets = ["input", "hidden", "results", "addButton"];

  showOptions() {
    this.fetchBrands();
  }

  handleInput() {
    const query = this.inputTarget.value.trim();
    this.fetchBrands(query);
  }

  async fetchBrands(query = "") {
    try {
      const url = query
        ? `${this.urlValue}?q=${encodeURIComponent(query)}`
        : this.urlValue;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const brands = await response.json();
      this.displayOptions(brands, query);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  }
  displayOptions(brands, query) {
    if (brands.length === 0 && !query) {
      this.resultsTarget.innerHTML = `<div class="p-2 text-gray-500">No brands found</div>`;
      return;
    }

    const options = brands.map((brand) => {
      return `<div class="p-2 hover:bg-gray-100 cursor-pointer" data-id="${brand.id}" data-name="${brand.name}" data-action="click->brand-select#select">
        ${brand.name}
      </div>`;
    });


    this.resultsTarget.innerHTML = `
      <div class="absolute z-10 mt-1 w-full bg-white shadow-lg border border-gray-300 rounded-md max-h-60 overflow-auto">
        ${options.join("")}
      </div>
    `;

    document.addEventListener("click", this.handleClickOutside.bind(this), {
      once: true,
    });
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.resultsTarget.innerHTML = "";
    }
  }

  select(event) {
    const id = event.currentTarget.dataset.id;
    const name = event.currentTarget.dataset.name;

    this.hiddenTarget.value = id;
    this.inputTarget.value = name;
    this.resultsTarget.innerHTML = "";
  }

  async openNewBrandModal() {
    this.resultsTarget.innerHTML = "";
    window.modalController.open("/brands/new_modal");
  }
}
